'use strct';
import $ from 'jquery';

export default class SliderContent {
	constructor() {
		if($('.slider-holder').length > 0){

			$(".slider-content").slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true
			});
			
		}
	}
}